import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f3c389c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "アクセス解析を希望するアカウントを選択してください。", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "選択されたプロパティ:", -1))

import { ref, onMounted,computed } from 'vue';
  import { method } from '../composables/useMethod';
  import { data } from '../composables/useData';
  import { useRouter } from 'vue-router';
  
export default /*#__PURE__*/_defineComponent({
  __name: 'GetAccessToken',
  setup(__props) {

  const router = useRouter();
  const showDialog = ref(false);
  
  onMounted(async () => {
    if(data.loginUser.first){ //初登録時のみの処理
      data.overlay = true;
      console.log('data.loginUser.uid', data.loginUser.uid);
      const url = new URL(window.location.href);
      const code = url.searchParams.get('code');
      const uid = url.searchParams.get('state');
      if(uid){ data.loginUser.uid = uid; }
      if(code){
        console.log(code);
        const result = await method.google.requestAccessToken(code);
        console.log('GetAccessToken.vue', result);
        const message = (result.data as { message: string }).message;
        if(message === 'success'){
          data.loginUser.googleTokens = true;
          const accountLists = await method.google.getGoogleAnalyticsAccounts();
          console.log('GetAccessToken getGoogleAnalyticsProperties', accountLists);
          const propertyLists = await method.google.getGoogleAnalyticsProperties();
          console.log('GetAccessToken getGoogleAnalyticsProperties', propertyLists);
        }
      }
      data.overlay = false;
    }
  });
  
  const confirmChanges = async () => {
    if(data.loginUser.first){
      await method.google.getGAData(router, data.loginUser.first);
    } else {
      await method.google.saveGoogleAnalyticsProperties();
    }
    showDialog.value = false;
  };

  const filteredProperties = computed(() => {
  return data.loginUser.reports.properties.filter(
    item => item.account === data.loginUser.reports.getAccountName
  );
});

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "fill-height" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Googleアカウント連携")
                    ]),
                    _: 1
                  }),
                  _withDirectives(_createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _hoisted_1,
                      _createVNode(_component_v_radio_group, {
                        modelValue: _unref(data).loginUser.reports.getAccountName,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(data).loginUser.reports.getAccountName) = $event)),
                        column: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).loginUser.reports.accounts, (item) => {
                            return (_openBlock(), _createBlock(_component_v_radio, {
                              key: item.name,
                              label: item.displayName + ' ' + item.name,
                              value: item.name
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, !_unref(data).loginUser.reports.getAccountName]
                  ]),
                  _withDirectives(_createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredProperties.value, (item) => {
                            return (_openBlock(), _createBlock(_component_v_list_item, {
                              key: item.account
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_checkbox, {
                                  modelValue: _unref(data).loginUser.reports.selectProperties,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(data).loginUser.reports.selectProperties) = $event)),
                                  label: item.displayName,
                                  value: item
                                }, null, 8, ["modelValue", "label", "value"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, _unref(data).loginUser.reports.getAccountName]
                  ]),
                  _createVNode(_component_v_card_actions, null, {
                    default: _withCtx(() => [
                      (_unref(data).loginUser.reports.getAccountName)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(data).loginUser.reports.getAccountName = ''))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("アカウント選択に戻る")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_btn, {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (showDialog.value = true)),
                        disabled: !_unref(data).loginUser.reports.selectProperties.length
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("変更を確認")
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_dialog, {
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showDialog).value = $event)),
        "max-width": "500"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, null, {
                default: _withCtx(() => [
                  _createTextVNode("変更内容の確認")
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).loginUser.reports.selectProperties, (item) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: item.name
                      }, _toDisplayString(item.displayName), 1))
                    }), 128))
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (showDialog.value = false))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("キャンセル")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, { onClick: confirmChanges }, {
                    default: _withCtx(() => [
                      _createTextVNode("確定")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_overlay, {
        modelValue: _unref(data).overlay,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(data).overlay) = $event)),
        class: "text-center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_progress_circular, {
            width: 7,
            size: 70,
            color: "primary",
            indeterminate: ""
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})